// extracted by css-extract-rspack-plugin
export default {"drop-top-wrapper":"BalanceCardTop-module__drop-top-wrapper--UkM6F","dropTopWrapper":"BalanceCardTop-module__drop-top-wrapper--UkM6F"};